<template>
    <div class="progress-bar">
        <div class="progress-bar__background">
            <div class="progress-bar__completed">
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">
import { computed } from 'vue'

export interface Props {
    completedPercentage?: number
}
const props = withDefaults(defineProps<Props>(), { completedPercentage: 0 })

const completedPercentageFormatted = computed(() => {
  return props.completedPercentage + '%'
})
</script>
<style lang="scss">
.progress-bar {
    display: flex;
    align-items: center;
    &__background {
        background-color: $grey-82;
        height: 24px;
        width: 100%;
    }
    &__completed {
        background-color: $purple;
        width: v-bind(completedPercentageFormatted);
        height: 24px;
        border-radius: 2px;
    }
}
</style>
